import { Link, useParams } from "react-router-dom";
import StandingsTestingBase from "../testing/StandingsTestingBase.jsx";

export default function ArchiveSeasonStandingsDb({ scopeType = "DRIVER", classKey = "", title = "Standings" }) {
    const { seasonKey } = useParams();
    const key = String(seasonKey || "").trim() || "active";

    return (
        <>
            <div className="card" style={{ marginBottom: 12 }}>
                <h2 style={{ marginBottom: 8 }}>{title} - {key.toUpperCase()}</h2>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Link className="btn" to={`/gt3x/archiv/${key}`}>Zur Season</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/results`}>Results</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/pro`}>PRO</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/int`}>INT</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/am`}>AM</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/team`}>TEAM</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/marke`}>MARKE</Link>
                </div>
            </div>
            <StandingsTestingBase
                seasonKey={key}
                scopeType={scopeType}
                classKey={classKey}
                title={`${title} (${key})`}
                subtitle="DB-Archivansicht der Standings."
            />
        </>
    );
}
